import PropTypes from 'prop-types'
import { Logout } from '../styled-components'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import { useHistory } from 'react-router-dom'
import { useIntercom } from 'react-use-intercom'

export const LogoutButton = ({ children }) => {
  const { logout } = useAuthStore()
  const history = useHistory()
  const { shutdown } = useIntercom()

  const handleLogout = async () => {
    shutdown()
    await logout()
    history.push('/')
  }

  return <Logout onClick={handleLogout}>{children}</Logout>
}

LogoutButton.propTypes = {
  children: PropTypes.object.isRequired
}

export default LogoutButton
